import { Controller } from "@hotwired/stimulus"
import SlimSelect from "slim-select"
import "slim-select/styles"

// Keeps the "Active websites" list in sync with the website multi-select:
// picked websites leave the dropdown (hideSelected) and appear in the list;
// removing one from the list puts it back in the dropdown. The select's
// selected options are the source of truth submitted with the form.
export default class extends Controller {
  static targets = ["select", "selectWrapper", "list", "allNote"]

  connect() {
    // SlimSelect snapshots select.className onto its container; Bootstrap's
    // .form-select caret would then render next to SlimSelect's own arrow.
    this.selectTarget.classList.remove("form-select")
    this.slimSelect = new SlimSelect({
      select: this.selectTarget,
      settings: {
        hideSelected: true,
        placeholderText: "Choose websites",
        searchPlaceholder: "Search websites",
        searchText: "No websites found",
      },
      events: {
        afterChange: () => this.render(),
      },
    })
    this.render()
  }

  disconnect() {
    this.slimSelect?.destroy()
  }

  remove(event) {
    const removed = event.currentTarget.dataset.value
    const remaining = Array.from(this.selectTarget.selectedOptions)
      .filter((option) => option.value !== removed)
      .map((option) => option.value)
    // Accepts option values and fires afterChange (which re-renders the list).
    this.slimSelect.setSelected(remaining)
    this.render()
  }

  scopeChanged(event) {
    const all = event.target.value === "all"
    this.selectWrapperTarget.classList.toggle("d-none", all)
    this.allNoteTarget.classList.toggle("d-none", !all)
    this.listTarget.classList.toggle("d-none", all)
  }

  render() {
    const selected = Array.from(this.selectTarget.selectedOptions)
    this.listTarget.innerHTML = ""
    if (!selected.length) {
      const item = document.createElement("li")
      item.className = "list-group-item px-0 py-1 text-muted"
      item.textContent = "No websites selected."
      this.listTarget.appendChild(item)
      return
    }
    for (const option of selected) {
      const item = document.createElement("li")
      item.className =
        "list-group-item d-flex justify-content-between align-items-center px-0 py-1"
      item.textContent = option.textContent
      const button = document.createElement("button")
      button.type = "button"
      button.className = "btn btn-link btn-sm text-muted p-0"
      button.setAttribute("aria-label", `Remove ${option.textContent}`)
      button.dataset.action = "site-activation#remove"
      button.dataset.value = option.value
      button.innerHTML = '<i class="bi bi-x-lg"></i>'
      item.appendChild(button)
      this.listTarget.appendChild(item)
    }
  }
}
